module.exports = __webpack_public_path__ + "static/media/HP.0cad8d27.jpg";